const isEnabled = (requested, available = []) =>
  requested.every(flag => available.indexOf(flag) !== -1)

export default ({ available }, enable = true) => {
  const loading = typeof available === 'undefined'
  const Flagger = ({ children, fallback, feature = [] }) => {
    let requested = [].concat(feature)
    const flag = enable == isEnabled(requested, available)
    Flagger.displayName =
      'Feature.' +
      (enable ? 'Enabled' : 'Disabled') +
      '[' +
      requested.join(',') +
      ']' +
      ' = [' +
      loading
        ? 'loading...'
        : available.join(',') + '] '
    if (loading) {
      return fallback || null
    } else {
      return flag ? children : null
    }
  }
  return Flagger
}
